import { makeStyles } from '@mui/styles';

export default makeStyles((theme: any) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    background: 'rgba(0, 0, 0, 0.8)',
    zIndex: 500,
  },
  modal: {
    ...theme.typography.p1,
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxSizing: 'border-box',
    outline: 0,
    padding: '20px 24px',
    position: 'relative',
    width: (props: { width: string }): string => props.width,
  },
  header: {
    ...theme.typography.h3,
    lineHeight: '24px',
    maxWidth: 'calc(100% - 24px)',
  },
  close: {
    color: theme.palette.grey[60],
    position: 'absolute',
    top: '10px',
    right: 0,
    padding: '15px',
    border: 0,
    background: 'none',
    outline: 0,
    cursor: 'pointer',
  },
}));
